<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <config-card :config="newConfig" :attributeErrors="attributeErrors">
        <template v-slot:title>
          <div />
        </template>
      </config-card>

      <md-button class="md-info" :disabled="isSaving" @click="saveConfig">
        Save
      </md-button>
      <md-button class="md-danger" @click="$router.push('/config')" style="margin-left: 1em">
        Cancel
      </md-button>
    </div>
  </div>
</template>

<script>
import ConfigCard from "@/components/Cards/Config/ConfigCard";
import { ConfigQuery, UpdateConfigMutation } from "@/graphql.js";
import _pick from "lodash/pick";
import _groupBy from "lodash/groupBy";
import _startCase from "lodash/startCase";

export default {
  name: "EditConfig",
  components: {
    ConfigCard,
  },
  data() {
    return {
      currentEdition: null,
      newConfig: {},
      attributeErrors: {},
      isSaving: false,
    }
  },
  created() {
    this.$apollo.query({ query: ConfigQuery })
    .then(({ data }) => { this.initConfig(data.config) })
    .catch((response) => {
      if (response.graphQLErrors.some(this.noConfigFound)) {
        console.log("No config found. Rendering form.");
      } else {
        console.error(response);
      }
    })
  },
  methods: {
    initConfig(config) {
      if (config) {
        this.currentEdition = config.edition;
        this.newConfig = { ...config, edition: null }
      }
    },
    noConfigFound(error) {
      return error.message.match(/\bno config/i);
    },
    async saveConfig() {
      this.isSaving = true;
      try {
        let attributes = _pick(this.newConfig, [
          "consumerAndroidForceVersion",
          "consumerAndroidLatestVersion",
          "consumerIosForceVersion",
          "consumerIosLatestVersion",
          "merchantAmazonForceVersion",
          "merchantAmazonLatestVersion",
          "merchantAndroidForceVersion",
          "merchantAndroidLatestVersion",
          "merchantIosForceVersion",
          "merchantIosLatestVersion",
          "merchantTabletUpgradeMessage",
          "merchantTabletUpgradeStartDate",
        ]);
        if (attributes.merchantTabletUpgradeMessage === '') {
          attributes.merchantTabletUpgradeMessage = null;
        }
        await this.$apollo.mutate({
          mutation: UpdateConfigMutation,
          variables: {
            updateConfigInput: {
              attributes: attributes,
              currentEdition: this.currentEdition,
            },
          },
          update: (store, { data: { updateConfig } }) => {
            const { currentEdition, configResult } = updateConfig;
            if (configResult.__typename === 'ConfigSuccess') {
              store.reset();
              this.initConfig(configResult.config);
              this.$router.push("/config")
            } else if (configResult.__typename === 'StaleConfigError') {
              alert(
                "Error: Your edit was based on an outdated config"
                + " (someone else already changed the config)."
                + " Please refresh the page (to pre-fill form based"
                + " on the latest config), then make your change(s)"
                + " and try again."
              )
            } else {
              // e.g. { path: ['attributes', 'merchantIosForceVersion'] }
              const attrName = ({ path }) => path[path.length - 1];
              this.attributeErrors = _groupBy(configResult.errors, attrName);
              const formatError = ([attr, xs]) => {
                const bullets = xs.map((x) => `* ${x.message}`);
                return `${_startCase(attr)}:\n${bullets.join('\n')}`
              };
              const msgs = Object.entries(this.attributeErrors).map(formatError);
              alert(`Failed to save config.\n\n${msgs.join('\n\n')}`);
            }
          },
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.isSaving = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
